import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  baseUrl = environment.apiUrl;

constructor(private http: HttpClient) { }

getLocationTreeByUserId(userId: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.get(this.baseUrl + 'Site/LocationsByUserId/' + userId, { headers: httpHeaders, observe: 'response' });
}

insertNewSite(model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.post(this.baseUrl + 'Site/AddNewSite' , model, {headers: httpHeaders, observe: 'response'});
}

addNewAuthority(model: any) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.post(this.baseUrl + `Site/AddNewAuthority`, model, {headers: httpHeaders, observe: 'response'});
} 

updateLocations(model: any) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.post(this.baseUrl + 'Site/UpdateLocations', model, {headers: httpHeaders, observe: 'response'});
}

removeLocation(id: number) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.delete(this.baseUrl + 'Site/' + id, {headers: httpHeaders, observe: 'response'});
}

getLocationDetail(model: any) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.post(this.baseUrl + `Site/GetLocationDetails`, model, {headers: httpHeaders, observe: 'response'});
}

getLocationDropDown() {
  return this.http.get(this.baseUrl + 'authorities/authorityDropDown');
}

getAllTopAuthorityNames() {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'Site/GetAllTopAuthorities', {headers: httpHeaders});
}

levelDropDown(id: number) {
  let tokenString = '';
    const securityToken: string = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders();
    if (securityToken != null) {
      tokenString = `Bearer ${securityToken}`;
      httpHeaders = new HttpHeaders()
        .set('authorization', tokenString)
        .set('Content-Type', 'application/json');
    } else {
      httpHeaders = new HttpHeaders()
        .set('Content-Type', 'application/json');
    }
  return this.http.get(this.baseUrl + 'Site/levelDropDown/' + id, {headers: httpHeaders});
}

locationHiararchy() {
  return this.http.get(this.baseUrl + 'authorities/AuthorityHierarchy');
}

adminLocationHierarchy() {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.get(this.baseUrl + 'Site/AdminLocationHierarchy', {headers: httpHeaders});
}


updateLocation(id: any, model: any) {
  let tokenString = '';
  const securityToken: string = localStorage.getItem('token');
  let httpHeaders = new HttpHeaders();
  if (securityToken != null) {
    tokenString = `Bearer ${securityToken}`;
    httpHeaders = new HttpHeaders()
      .set('authorization', tokenString)
      .set('Content-Type', 'application/json');
  } else {
    httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
  }
  return this.http.put(this.baseUrl + `Site/UpdatSiteAdminLocations/` + id, model,
  { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
}
}

